export const hasCorrectAnswer = (options) => {
    for (let i = 0; i < options.length; i++) {
      if (options[i].isCorrect) {
        return true;
      }
    }
    return false;
  }